import React from 'react';
import { Button } from '../../../../components';
import { FormattedMessage } from '../../../../util/reactIntl';
import css from '../PickupModal.css';
import TransactionTabs from '../../utils/TransactionTabs';
import { categorizeTransactions } from '../../../../containers/TransactionPage/helpers';

const SuspiciousTransactionsStep = ({ customerTransactions, onBack, onNext, txId, currentUser, transaction }) => {
  const { ongoing, overdue, notPaidServiceFees } = categorizeTransactions(customerTransactions, txId);

  const tabs = [
    { id: 'overdue', label: 'Zaległe', data: overdue },
    { id: 'ongoing', label: 'W toku', data: ongoing },
    ...(process.env.REACT_APP_COUNTRY_ID === 'pl'
      ? [{ id: 'serviceFees', label: 'Opłaty serwisowe', data: notPaidServiceFees }]
      : [])
  ];

  return (
    <>
      <h2>Transakcje wymagające weryfikacji</h2>
      <div className={css.duplicatedPeselWarning}>
        <FormattedMessage
          id="PickupModal.duplicatedPeselWarning"
          defaultMessage="Uwaga! Istnieją inne transakcje z tym samym numerem PESEL/numerem dokumentu. Zweryfikuj dokładnie listę wypożyczeń przed wydaniem sprzętu."
        />
      </div>
      <TransactionTabs
        tabs={tabs}
        currentUser={currentUser}
        displayReceiver
      />

      <div className={css.actions}>
        <a type="button" onClick={onBack} className={css.back}>Wstecz</a>
        <Button type="button" onClick={onNext}>Dalej</Button>
      </div>
    </>
  );
};

export default SuspiciousTransactionsStep;
